import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'keepHtml', pure: true,
    standalone: false
})
export class keepHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(content: any) {
  if (content != undefined) {
      content = content.split('&amp;').join('&');
      return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    return "";
    //return this.sanitizer.sanitize(SecurityContext.HTML, content);
  }
}
